import React from "react";
import { Navigate } from "react-router-dom";

import Login from "../pages/Authentication/Login";
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import Landing from "../pages/Home";

//Dashboard
import Dashboard from "../pages/Dashboard";

//Company
import Client from "../pages/Corporate/Client";
import Company from "../pages/Corporate/Company";
import Brand from "../pages/Corporate/Brand";
import Branch from "../pages/Corporate/Branch";
import Project from "../pages/Corporate/Branch";

//Address
import Address from "../pages/Corporate/Address";
import Province from "../pages/Corporate/Address";
import City from "../pages/Corporate/Address";
import District from "../pages/Corporate/Address";
import Village from "../pages/Corporate/Address";

import Bank from "../pages/Corporate/Address";
import BankData from "../pages/Corporate/Address";

import Uom from "../pages/Procurement/Uom";

// User Profile
import UserProfile from "../pages/Profile/";

//Human Resources
import Employee from "../pages/HR/Employee";
import Department from "../pages/HR/Department";
import Position from "../pages/HR/Position";
import Structure from "../pages/HR/Structure";
import EmployeeContract from "../pages/HR/EmployeeContract";
import EmployeeLocation from "../pages/HR/EmployeeLocation";
import EmployeeWarning from "../pages/HR/EmployeeWarning";
import Termination from "../pages/HR/Terminations";
import PositionChange from "../pages/HR/PositionChange";
import Payrate from "../pages/HR/Payrate";
import Calendar from "../pages/HR/Calendar";
import AttSchedule from "../pages/HR/Schedule";
import PayrollComponent from "../pages/HR/Component";
import WorkGroup from "../pages/HR/Group";
import AttEvent from "../pages/HR/Event";
import FaceRegistration from "../pages/HR/Face";
import Attendance from "../pages/HR/Attendance";
import AttendanceSummary from "../pages/HR/AttendanceSummary";
import Permission from "../pages/HR/Permission";
import PerformancePredicate from "../pages/HR/PerformancePredicate";
import PerformanceScore from "../pages/HR/PerformanceScore";
import PerformanceAppraisal from "../pages/HR/PerformanceAppraisal";
import SelfAssessment from "../pages/HR/Assessment";
import Assessment360 from "../pages/HR/Assessment360";
import JobPerformance from "../pages/HR/Performance";
import Loan from "../pages/HR/Loan";

import TaskList from "../pages/Task/TaskList";
import Ticket from "../pages/Task/Ticket";
import Task from "../pages/Task";
import TaskDetail from "../pages/Task/Detail";
import TaskCategory from "../pages/Task/TaskCategory";

//Product
import Product from "../pages/Product";
import Material from "../pages/Product/Material";
import ProductGeneral from "../pages/Product/General";
import ProductOption from "../pages/Product/Option";
import ProductTag from "../pages/Product/Tag";
import ProductCategory from "../pages/Product/Category";
import ProductBlock from "../pages/Product/Block";
import ProductVarian from "../pages/Product/Detail";
import ProductPurchaseInbound from "../pages/Product/Inbound/Purchase";
import ProductTransferInbound from "../pages/Product/Inbound/Transfer";
import ProductInventory from "../pages/Product/Inventory";
import ProductTransfer from "../pages/Product/Transfer";
import ProductTransferBlock from "../pages/Product/Transfer/block.js";
import ProductDelivery from "../pages/Product/Delivery";

//Asset
import AssetCategory from "../pages/Asset/Category";
import Asset from "../pages/Asset";
import AssetTag from "../pages/Asset/Tag";
import AssetInspection from "../pages/Asset/Inspection";
import AssetInspectionCategory from "../pages/Asset/InspectionCategory";
import AssetClass from "../pages/Asset/Class";
import Legal from "../pages/Asset/Legality";
import LegalMaster from "../pages/Asset/LegalityMaster";
import LegalAsset from "../pages/Asset/LegalityAsset";
import LegalityType from "../pages/Asset/LegalityType";

//Vendor
import Vendor from "../pages/Procurement/Vendor";
import ShipmentMethod from "../pages/Procurement/ShipmentMethod";
import ShipmentCarrier from "../pages/Procurement/ShipmentCarrier";
import Purchase from "../pages/Procurement";
import PurchaseGeneral from "../pages/Procurement/General";

//Sales
import ProductDistribution from "../pages/Sales/Distribution";
import SalesTarget from "../pages/Sales/SalesTarget";
import POS from "../pages/Sales/POS";
import Customer from "../pages/Sales/Customer";
import Sales from "../pages/Sales/Order";
import SalesLegality from "../pages/Sales/Legality";
import SalesComplain from "../pages/Sales/Complain";
import SalesFee from "../pages/Sales/Fee";
import SalesApplicant from "../pages/Sales/Applicant";
import Campaign from "../pages/Sales/Campaign";
import CampaignPage from "../pages/Sales/CampaignPage";
import ApplicantDocument from "../pages/Sales/ApplicantDocument";
import SalesReport from "../pages/Sales/Report";
import SalesManagement from "../pages/Sales/Management";
import SalesDocument from "../pages/Sales/Document";
import SalesAnalytic from "../pages/Sales/Analytic";
import BankManagement from "../pages/Sales/Bank";

//Accounting
import SalesPromo from "../pages/Accounting/SalesPromo";
import PaymentMethod from "../pages/Accounting/PaymentMethod";
import TransactionTax from "../pages/Accounting/TransactionTax";
import PaymentTerm from "../pages/Accounting/PaymentTerm";
import AccCategory from "../pages/Accounting/Category";
import AccAccount from "../pages/Accounting/Account";
import AccSales from "../pages/Accounting/Sales";
import AccTag from "../pages/Accounting/Tag";
import Ledger from "../pages/Accounting/Ledger";
import AccTrans from "../pages/Accounting/Transaction";
import LoanTerm from "../pages/Accounting/LoanTerm";
import ReimbursementType from "../pages/Accounting/ReimbursementType";
import AccSetting from "../pages/Accounting/Setting";
import AccBudget from "../pages/Accounting/Budget";
import Payable from "../pages/Accounting/Payable";
import PayableAll from "../pages/Accounting/PayableAll";
import Receivable from "../pages/Accounting/Receivable";
import Expense from "../pages/Accounting/Expense";

import Storage from "../pages/Storage";
import Mail from "../pages/Mail";

//USers
import Users from "../pages/Users";
import Reimbursement from "../pages/HR/Reimbursement";

import Disposal from "../pages/Asset/Disposal";
import Depreciation from "../pages/Asset/Depreciation";
import QRLanding from "../pages/Landing/qr";

import Budget from "../pages/Budgeting";

///REPORT
import ReportAttendance from "../pages/Report/HumanResources/reportAttendance";

import ReportSalesSummary from "../pages/Report/Sales/SalesSummary";
import ReportSales from "../pages/Report/Sales/Sales";
import ReportSalesDaily from "../pages/Report/Sales/SalesDaily";
import ReportSalesProduct from "../pages/Report/Sales/SalesProduct";
import ReportSalesVendor from "../pages/Report/Sales/SalesVendor";
import ReportSalesCategory from "../pages/Report/Sales/SalesCategory";
import ReportSalesBranch from "../pages/Report/Sales/SalesBranch";
import ReportSalesCompany from "../pages/Report/Sales/SalesCompany";
import ReportSalesPaymentType from "../pages/Report/Sales/SalesPaymentType";
import ReportSalesReturn from "../pages/Report/Sales/SalesReturn";
import ReportSalesRefund from "../pages/Report/Sales/SalesRefund";
import ReportSalesTax from "../pages/Report/Sales/SalesTax";
import ReportSalesClosing from "../pages/Report/Sales/SalesClosing";
import ReportSalesCustomer from "../pages/Report/Sales/SalesCustomer";
import ReportSalesCustomerPoint from "../pages/Report/Sales/SalesCustomerPoint";
import ReportSalesCoupon from "../pages/Report/Sales/SalesCoupon";
import ReportSalesCompliment from "../pages/Report/Sales/SalesCompliment";
import ReportSalesPromotion from "../pages/Report/Sales/SalesPromotion";
import ReportSalesCRM from "../pages/Report/Sales/SalesCRM";
import ReportSalesTarget from "../pages/Report/Sales/SalesTarget";
import ReportAssetStock from "../pages/Report/AssetInventories/AssetStock";
import ReportAssetStockCard from "../pages/Report/AssetInventories/AssetStockCard";
import ReportAssetStockBranch from "../pages/Report/AssetInventories/AssetStockBranch";
import ReportAssetStockCompany from "../pages/Report/AssetInventories/AssetCompany";
import ReportAssetStockFoundLoss from "../pages/Report/AssetInventories/AssetStockFoundLoss";
import ReportAssetStockDistribution from "../pages/Report/AssetInventories/AssetStockDistribution";

import LeaveReport from "../pages/Report/HumanResources/LeaveReport";
import ReportPermission from "../pages/Report/HumanResources/reportPermission";
import ReportPerformance from "../pages/Report/HumanResources/reportPerformance";
import ReportPayRoll from "../pages/Report/HumanResources/reportPayroll";
import ReportAllowance from "../pages/Report/HumanResources/reportAllowance";
import ReportDeduction from "../pages/Report/HumanResources/reportDeduction";
import ReportPPH21 from "../pages/Report/HumanResources/reportPPH21";
import ReportPurchaseSummary from "../pages/Report/Procurement/reportPurchaseSummary";
import ReportPurchaseReport from "../pages/Report/Procurement/reportPurchaseReport";
import ReportPurchaseProduct from "../pages/Report/Procurement/reportPurchaseProduct";
import ReportPurchaseDepartement from "../pages/Report/Procurement/reportPurchaseDepartement";
import ReportPurchaseVendor from "../pages/Report/Procurement/reportPurchaseVendor";
import ReportPurchaseCategory from "../pages/Report/Procurement/reportPurchaseCategory";
import ReportPurchaseBranch from "../pages/Report/Procurement/reportPurchaseBranch";
import ReportPurchaseCompany from "../pages/Report/Procurement/reportPurchaseCompany";
import ReportPurchasePaymentType from "../pages/Report/Procurement/reportPurchasePaymentType";
import ReportPurchaseReturn from "../pages/Report/Procurement/reportPurchaseReturn";
import ReportPurchaseTax from "../pages/Report/Procurement/reportPurchaseTax";
import ReportProductStock from "../pages/Report/ProductInventory/reportProductStock";
import ReportProductStockCard from "../pages/Report/ProductInventory/reportProductStockCard";
import ReportProductStockBranch from "../pages/Report/ProductInventory/reportProductStockBranch";
import ReportProductStockCompany from "../pages/Report/ProductInventory/reportProductStockCompany";
import ReportProductStockFoundLoss from "../pages/Report/ProductInventory/reportProductStockFoundLoss";
import ReportProductStockDistribution from "../pages/Report/ProductInventory/reportProductStockDistribution";
import ReportProductionCost from "../pages/Report/Production/reportProductionCost";
import ReportProductionRealization from "../pages/Report/Production/reportProductionRealization";
import PayrollSalary from "../pages/HR/PayrollSalary";
import TicketCategory from "../pages/Task/TicketCategory";
import PrintTemplate from "../pages/Task/PrintTemplate";
import CrmContacts from "../pages/Sales/CRM/CrmContacts";
import CrmDeals from "../pages/Sales/CRM/CrmDeals";
import DealTag from "../pages/Sales/CRM/Tag";
import StockCard from "../pages/Product/Inventory/StockCard";
import StockAdjustment from "../pages/Product/Adjustment";
import SalesChannel from "../pages/Sales/SalesChannel";
import SalesType from "../pages/Sales/SalesType";
import DealStatus from "../pages/Sales/CRM/Status";
import CustomerGroup from "../pages/Sales/CustomerGroup";
import CreditOption from "../pages/Product/CreditOption";

//Survey
import SurveyScore from "../pages/Sales/Survey/Score";
import SurveyTemplate from "../pages/Sales/Survey/Template";
import Survey from "../pages/Sales/Survey";

//Agency
import Agent from "../pages/Sales/Agent";
import Agency from "../pages/Sales/Agency";
import Content from "../pages/Content";
import ContentNews from "../pages/Content";
import ContentBanner from "../pages/Content";
import ContentSingleBanner from "../pages/Content";
import ContentAbout from "../pages/Content";
import ContentKPR from "../pages/Content";
import ContentHelp from "../pages/Content";
import ContentCategory from "../pages/Content/Category";
import DealTable from "../pages/Sales/CRM/DealTable";

//Landing Page
import LandingAds from "../pages/Landing";

//civil-material
import BudgetAccountCategory from "../pages/Engineering/BudgetCategory";
import BudgetAccountItems from "../pages/Engineering/BudgetItems";
import CivilBudget from "../pages/Engineering/CivilBudget";
import CivilBudgetControl from "../pages/Engineering/CivilBudgetControl";
import CivilBudgetControlMaterial from "../pages/Engineering/CivilBudgetControlMaterial";
import CivilBudgetSchedule from "../pages/Engineering/CivilBudgetSchedule";
import CivilBudgetMonitoring from "../pages/Engineering/CivilBudgetMonitoring";
import CivilProgression from "../pages/Engineering/CivilProgression";
import CivilContract from "../pages/Engineering/CivilContract";
import CivilOpname from "../pages/Engineering/CivilOpname";
import DashboardWithCredential from "../pages/DashboardWithCredential";
import Credential from "../pages/Authentication/Credential";
import ReportSalesBank from "../pages/Report/Sales/SalesBank";
import SalesReport2 from "../pages/Report/Sales/SalesUnit";
import LegalityDocument from "../pages/Sales/LegalityDocument";

import ProductHandover from "../pages/Product/Handover";
import HandoverList from "../pages/Sales/HandoverList";
import FollowupList from "../pages/Asset/FollowupList";
import ReportPurchaseMaterial from "../pages/Report/Procurement/reportPurchaseMaterial";
import ReportPurchaseGeneral from "../pages/Report/Procurement/reportPurchaseGeneral";
import HandoverListEngineering from "../pages/Engineering/HandoverListEngineering";
import ReportTransaction from "../pages/Report/Finance/ReportTransaction";
import Nominatif from "../pages/Asset/Nominatif";
import ReportTransactionTechical from "../pages/Report/Finance/ReportBalance";
import Notif from "../pages/Notif";
import LegalSiteplan from "../pages/Sales/CRM/CrmDeals";
import LegalPeil from "../pages/Licensing/LegalPeil";
import LegalBridge from "../pages/Licensing/LegalBridge";
import LegalRumija from "../pages/Licensing/LegalRumija";
import LegalPermission from "../pages/Asset/LegalPermission";
import LegalityFractional from "../pages/Asset/LegalityFractional";
import LegalityNotary from "../pages/Asset/Notary";
import LegalitySTF from "../pages/Asset/Notary/stf";
import LegalityProgressNotary from "../pages/Asset/Notary/notary";
import LegalityTerm from "../pages/Asset/Notary/term";
import LegalityCheck from "../pages/Asset/Notary/check";
import LegalityAjb from "../pages/Asset/Notary/ajb";
import LegalityBn from "../pages/Asset/Notary/bn";
import DashboardEnginering from "../pages/Dashboard/Enginering/Progress";
import DashboardEnginering2 from "../pages/Dashboard/Enginering/Opname";
import DashboardEnginering3 from "../pages/Dashboard/Enginering/Material";
import BalanceSheet from "../pages/Accounting/Report/BalanceSheet";
import ProfitLoss from "../pages/Accounting/Report/ProfitLoss";
import LedgerDetail from "../pages/Accounting/LedgerDetail";

import Admin from "../pages/Admin";

const authProtectedRoutes = [
  { path: "/index", component: <Dashboard /> },
  { path: "/dashboard-general", component: <Dashboard /> },
  { path: "/dashboard-enginering-progress", component: <DashboardEnginering /> },
  { path: "/dashboard-enginering-opname", component: <DashboardEnginering2 /> },
  { path: "/dashboard-enginering-material", component: <DashboardEnginering3 /> },
  { path: "/budget", component: <Budget /> },
  { path: "/client", component: <Client /> },
  { path: "/company", component: <Company /> },
  { path: "/brand", component: <Brand /> },
  { path: "/branch", component: <Branch /> },
  { path: "/attendance-location", component: <Branch /> },
  { path: "/profile", component: <UserProfile /> },
  { path: "/address", component: <Address /> },
  { path: "/province", component: <Province /> },
  { path: "/city", component: <City /> },
  { path: "/district", component: <District /> },
  { path: "/village", component: <Village /> },
  { path: "/bank", component: <Bank /> },
  { path: "/bank-data", component: <BankData /> },
  { path: "/employee", component: <Employee /> },
  { path: "/department", component: <Department /> },
  { path: "/position", component: <Position /> },
  { path: "/structure", component: <Structure /> },
  { path: "/employee-contract", component: <EmployeeContract /> },
  { path: "/employee-location", component: <EmployeeLocation /> },
  { path: "/warning-letter", component: <EmployeeWarning /> },
  { path: "/pay-rate", component: <Payrate /> },
  { path: "/position-change", component: <PositionChange /> },
  { path: "/termination", component: <Termination /> },
  { path: "/calendar", component: <Calendar /> },
  { path: "/attendance-schedule", component: <AttSchedule /> },
  { path: "/payroll-component", component: <PayrollComponent /> },
  { path: "/payroll-salary", component: <PayrollSalary /> },
  { path: "/work-group", component: <WorkGroup /> },
  { path: "/attendance-event", component: <AttEvent /> },
  { path: "/attendance-face", component: <FaceRegistration /> },
  { path: "/attendance", component: <Attendance /> },
  { path: "/attendance-summary", component: <AttendanceSummary /> },
  { path: "/permission", component: <Permission /> },
  { path: "/performance-predicate", component: <PerformancePredicate /> },
  { path: "/performance-score", component: <PerformanceScore /> },
  { path: "/performance-appraisal", component: <PerformanceAppraisal /> },
  { path: "/performance-assessment", component: <SelfAssessment /> },
  { path: "/performance-360", component: <Assessment360 /> },
  { path: "/performance", component: <JobPerformance /> },
  { path: "/loan-term", component: <LoanTerm /> },
  { path: "/loan", component: <Loan /> },
  { path: "/reimbursement", component: <Reimbursement /> },
  { path: "/reimbursement-type", component: <ReimbursementType /> },

  ///PRODUCT
  { path: "/material", component: <Material /> },
  { path: "/product-general", component: <ProductGeneral /> },
  { path: "/product", component: <Product /> },
  { path: "/product-option", component: <ProductOption /> },
  { path: "/product-tag", component: <ProductTag /> },
  { path: "/product-category", component: <ProductCategory /> },
  { path: "/product-block", component: <ProductBlock /> },
  { path: "/product-varian", component: <ProductVarian /> },
  { path: "/product-purchase-inbound", component: <ProductPurchaseInbound /> },
  { path: "/product-transfer-inbound", component: <ProductTransferInbound /> },
  { path: "/product-inventory", component: <ProductInventory /> },
  { path: "/product-stock-card", component: <StockCard /> },
  { path: "/product-stock-adjustment", component: <StockAdjustment /> },
  { path: "/product-handover", component: <ProductHandover /> },

  //
  { path: "/credit-option", component: <CreditOption /> },

  ///ASSET
  { path: "/asset", component: <Asset /> },
  { path: "/asset-inspection", component: <AssetInspection /> },
  { path: "/asset-inspection-category", component: <AssetInspectionCategory /> },
  { path: "/asset-category", component: <AssetCategory /> },
  { path: "/asset-tag", component: <AssetTag /> },
  { path: "/asset-class", component: <AssetClass /> },
  { path: "/uom", component: <Uom /> },
  { path: "/asset-disposal", component: <Disposal /> },
  { path: "/asset-depreciation", component: <Depreciation /> },
  { path: "/legality-type", component: <LegalityType /> },
  { path: "/legality-asset", component: <LegalAsset /> },
  { path: "/followup-lists", component: <FollowupList /> },
  { path: "/nominatif", component: <Nominatif /> },

  ///PROCUREMENT
  { path: "/vendor-brand", component: <Brand /> },
  { path: "/vendor", component: <Vendor /> },
  { path: "/shipping-method", component: <ShipmentMethod /> },
  { path: "/shipping-carrier", component: <ShipmentCarrier /> },
  { path: "/purchase", component: <Purchase /> },
  { path: "/payable", component: <Payable /> },
  { path: "/payable-all", component: <PayableAll /> },
  { path: "/receivable", component: <Receivable /> },
  { path: "/purchase-general", component: <PurchaseGeneral /> },

  ///SALES
  { path: "/sales", component: <Sales /> },
  { path: "/sales-applicant", component: <SalesApplicant /> },
  { path: "/sales-fee", component: <SalesFee /> },
  { path: "/sales-promo", component: <SalesPromo /> },
  { path: "/sales-legality", component: <SalesLegality /> },
  { path: "/sales-complain", component: <SalesComplain /> },
  { path: "/product-transfer", component: <ProductTransfer /> },
  { path: "/product-transfer-block", component: <ProductTransferBlock /> },
  { path: "/product-delivery", component: <ProductDelivery /> },
  { path: "/product-distribution", component: <ProductDistribution /> },
  { path: "/sales-target", component: <SalesTarget /> },
  { path: "/sales-channel", component: <SalesChannel /> },
  { path: "/sales-type", component: <SalesType /> },

  { path: "/bank-management", component: <BankManagement /> },
  { path: "/sales-management", component: <SalesManagement /> },
  { path: "/sales-document", component: <SalesDocument /> },
  { path: "/sales-analytic", component: <SalesAnalytic /> },
  { path: "/sales-report", component: <SalesReport /> },
  { path: "/pos", component: <POS /> },
  { path: "/customer", component: <Customer /> },
  { path: "/customer-group", component: <CustomerGroup /> },
  { path: "/campaign", component: <Campaign /> },
  { path: "/campaign-template", component: <CampaignPage /> },
  { path: "/applicant-document", component: <ApplicantDocument /> },
  { path: "/legality-document", component: <LegalityDocument /> },
  { path: "/handover-lists", component: <HandoverList /> },

  ///CRM
  { path: "/crm-contacts", component: <CrmContacts /> },
  { path: "/crm-deals", component: <CrmDeals /> },
  { path: "/deal-tags", component: <DealTag /> },
  { path: "/deal-statues", component: <DealStatus /> },
  { path: "/deal-table", component: <DealTable /> },

  ///ACCOUNTING
  { path: "/payment-method", component: <PaymentMethod /> },
  { path: "/payment-term", component: <PaymentTerm /> },
  { path: "/transaction-tax", component: <TransactionTax /> },
  { path: "/acc-category", component: <AccCategory /> },
  { path: "/acc-account", component: <AccAccount /> },
  { path: "/acc-tag", component: <AccTag /> },
  { path: "/acc-trans", component: <AccTrans /> },
  { path: "//acc-trans/:id", component: <AccTrans /> },
  { path: "/acc-ledger", component: <Ledger /> },
  { path: "/ledger-detail/:id", component: <LedgerDetail /> },
  { path: "/acc-budget", component: <AccBudget /> },
  { path: "/acc-setting", component: <AccSetting /> },
  { path: "/acc-sales", component: <AccSales /> },
  { path: "/project", component: <Project /> },
  { path: "/legality", component: <Legal /> },
  { path: "/legality-master", component: <LegalMaster /> },
  { path: "/legality-fractional", component: <LegalityFractional /> },
  { path: "/legality-notary", component: <LegalityNotary /> },
  { path: "/legality-progress-notary", component: <LegalityProgressNotary /> },
  { path: "/legality-stf", component: <LegalitySTF /> },
  { path: "/legality-term", component: <LegalityTerm /> },
  { path: "/legality-check", component: <LegalityCheck /> },
  { path: "/legality-ajb", component: <LegalityAjb /> },
  { path: "/legality-bn", component: <LegalityBn /> },

  { path: "/expense", component: <Expense /> },

  { path: "/storage", component: <Storage /> },
  { path: "/message", component: <Mail /> },
  { path: "/task-list", component: <TaskList /> },
  { path: "/task-category", component: <TaskCategory /> },
  { path: "/task", component: <Task /> },
  { path: "/task-detail/:taskId", component: <TaskDetail /> },
  { path: "/ticket", component: <Ticket /> },
  { path: "/ticket-category", component: <TicketCategory /> },
  { path: "/users", component: <Users /> },

  //Finance report
  { path: "/balance-sheet", component: <BalanceSheet /> },
  { path: "/profit-loss", component: <ProfitLoss /> },

  //REPORT
  { path: "/report-attendance", component: <ReportAttendance /> },
  { path: "/report-leave", component: <LeaveReport /> },
  { path: "/report-permission", component: <ReportPermission /> },
  { path: "/report-performance", component: <ReportPerformance /> },
  { path: "/report-payroll", component: <ReportPayRoll /> },
  { path: "/report-allowance", component: <ReportAllowance /> },
  { path: "/report-deduction", component: <ReportDeduction /> },
  { path: "/report-pph21", component: <ReportPPH21 /> },

  { path: "/report-sales-daily", component: <ReportSalesDaily /> },
  { path: "/report-sales-bank", component: <ReportSalesBank /> },
  { path: "/report-sales-unit", component: <SalesReport2 /> },
  { path: "/report-sales-summary", component: <ReportSalesSummary /> },
  { path: "/report-sales-report", component: <ReportSales /> },
  { path: "/report-sales-product", component: <ReportSalesProduct /> },
  { path: "/report-sales-vendor", component: <ReportSalesVendor /> },
  { path: "/report-sales-category", component: <ReportSalesCategory /> },
  { path: "/report-sales-branch", component: <ReportSalesBranch /> },
  { path: "/report-sales-company", component: <ReportSalesCompany /> },
  { path: "/report-sales-payment-type", component: <ReportSalesPaymentType /> },
  { path: "/report-sales-return", component: <ReportSalesReturn /> },
  { path: "/report-sales-refund", component: <ReportSalesRefund /> },
  { path: "/report-sales-tax", component: <ReportSalesTax /> },
  { path: "/report-sales-closing", component: <ReportSalesClosing /> },
  { path: "/report-sales-customer", component: <ReportSalesCustomer /> },
  { path: "/report-sales-customer-point", component: <ReportSalesCustomerPoint /> },
  { path: "/report-sales-coupon", component: <ReportSalesCoupon /> },
  { path: "/report-sales-compliment", component: <ReportSalesCompliment /> },
  { path: "/report-sales-promotion", component: <ReportSalesPromotion /> },
  { path: "/report-sales-crm", component: <ReportSalesCRM /> },
  { path: "/report-sales-target", component: <ReportSalesTarget /> },
  { path: "/report-asset-stock", component: <ReportAssetStock /> },
  { path: "/report-asset-stock-card", component: <ReportAssetStockCard /> },
  { path: "/report-asset-stock-branch", component: <ReportAssetStockBranch /> },
  { path: "/report-asset-company", component: <ReportAssetStockCompany /> },
  {
    path: "/report-asset-stock-found-loss",
    component: <ReportAssetStockFoundLoss />,
  },
  {
    path: "/report-asset-stock-distribution",
    component: <ReportAssetStockDistribution />,
  },

  { path: "/report-purchase-summary", component: <ReportPurchaseSummary /> },
  { path: "/report-purchase-report", component: <ReportPurchaseReport /> },
  { path: "/report-purchase-product", component: <ReportPurchaseProduct /> },
  {
    path: "/report-purchase-department",
    component: <ReportPurchaseDepartement />,
  },
  { path: "/report-purchase-vendor", component: <ReportPurchaseVendor /> },
  { path: "/report-purchase-category", component: <ReportPurchaseCategory /> },
  { path: "/report-purchase-branch", component: <ReportPurchaseBranch /> },
  { path: "/report-purchase-company", component: <ReportPurchaseCompany /> },
  {
    path: "/report-purchase-payment-type",
    component: <ReportPurchasePaymentType />,
  },
  { path: "/report-purchase-return", component: <ReportPurchaseReturn /> },
  { path: "/report-purchase-tax", component: <ReportPurchaseTax /> },

  { path: "/report-product-stock", component: <ReportProductStock /> },
  { path: "/report-product-stock-card", component: <ReportProductStockCard /> },
  {
    path: "/report-product-stock-branch",
    component: <ReportProductStockBranch />,
  },
  { path: "/report-stock-company", component: <ReportProductStockCompany /> },
  {
    path: "/report-product-stock-found-loss",
    component: <ReportProductStockFoundLoss />,
  },
  {
    path: "/report-product-stock-distribution",
    component: <ReportProductStockDistribution />,
  },

  { path: "/report-civil_budget-cost", component: <ReportProductionCost /> },
  {
    path: "/report-civil_budget-realization",
    component: <ReportProductionRealization />,
  },
  { path: "/report-purchase-material", component: <ReportPurchaseMaterial /> },
  { path: "/report-purchase-general", component: <ReportPurchaseGeneral /> },
  { path: "/report-transaction", component: <ReportTransaction /> },
  { path: "/report-account-balance", component: <ReportTransactionTechical /> },

  { path: "/print-template", component: <PrintTemplate /> },

  { path: "/survey-scores", component: <SurveyScore /> },
  { path: "/survey-templates", component: <SurveyTemplate /> },
  { path: "/surveys", component: <Survey /> },

  { path: "/agents", component: <Agent /> },
  { path: "/agencies", component: <Agency /> },
  { path: "/content", component: <Content /> },
  { path: "/content-news", component: <ContentNews name="Berita" /> },
  { path: "/content-banner", component: <ContentBanner name="Banner" /> },
  { path: "/content-single-banner", component: <ContentSingleBanner name="Single Banner" /> },
  { path: "/content-help", component: <ContentHelp name="Bantuan" /> },
  { path: "/content-about", component: <ContentAbout name="About" /> },
  { path: "/content-kpr", component: <ContentKPR name="KPR" /> },
  { path: "/content-categories", component: <ContentCategory /> },

  //civil-material
  { path: "/budgetAccountCategories", component: <BudgetAccountCategory /> },
  { path: "/budgetAccountItems", component: <BudgetAccountItems /> },
  { path: "/civilBudget", component: <CivilBudget /> },
  { path: "/civilContract", component: <CivilContract /> },
  { path: "/civil-budget-control", component: <CivilBudgetControl /> },
  { path: "/civil-budget-control-material", component: <CivilBudgetControlMaterial /> },
  { path: "/civil-progression", component: <CivilProgression /> },
  { path: "/civil-opname", component: <CivilOpname /> },
  { path: "/civilBudgetSchedule", component: <CivilBudgetSchedule /> },
  { path: "/civilBudgetMonitoring", component: <CivilBudgetMonitoring /> },
  { path: "/handover-engineering-lists", component: <HandoverListEngineering /> },

  { path: "/notif", component: <Notif /> },
  { path: "/admin", component: <Admin /> },

  //perizinan

  // { path: "/legal-siteplan", component: <LegalSiteplan /> },
  // { path: "/legal-peil", component: <LegalPeil /> },
  // { path: "/legal-bridge", component: <LegalBridge /> },
  // { path: "/legal-rumija", component: <LegalRumija /> },

  { path: "/legal-permission", component: <LegalPermission /> },

  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard-general" />,
  },
  { path: "*", component: <Navigate to="/dashboard-general" /> },
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/register", component: <Register /> },
  { path: "/home", component: <Landing /> },
  { path: "/promo/:id", component: <LandingAds /> },
  { path: "/credential/:data", component: <Credential /> },
  { path: "/dashboard/credential/:companyId/:branchId", component: <DashboardWithCredential /> },
  { path: "/qr/:salesId", component: <QRLanding /> },
];

export { authProtectedRoutes, publicRoutes };
